// openEHR RM model — barrel for rm.data_types.quantity
// Generated by tasks/split_model_by_bmm_packages.ts from tasks/bmm_package_map.json.
// Package boundaries follow the BMM package structure; edit the class bodies here,
// but re-run the splitter rather than hand-moving declarations between packages.

export * from "./date_time.ts";
